module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "title": "Rolls, Breads, & Muffins"
    }
  }, [_c('div', {
    staticClass: "titlepage"
  }, [_c('div', [_c('div', [_c('h1', {
    staticClass: "title"
  }, [_c('a', {
    attrs: {
      "id": "d0e54",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Rolls, Breads,\n              & Muffins ")])]), _c('a', {
    attrs: {
      "id": "d0e54",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  })]), _c('a', {
    attrs: {
      "id": "d0e54",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  })]), _c('a', {
    attrs: {
      "id": "d0e54",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  })]), _c('a', {
    attrs: {
      "id": "d0e54",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }), _c('h2', {
    staticClass: "nodivide"
  }, [_c('a', {
    attrs: {
      "id": "d0e54",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }), _c('a', {
    attrs: {
      "id": "d0e57",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Cinnamon Rolls ")])]), _c('a', {
    attrs: {
      "id": "d0e57",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('table', {
    staticClass: "simplelist",
    attrs: {
      "border": "0",
      "summary": "Simple list"
    }
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("4 cups bread flour ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1/2 small box instant vanilla pudding mix ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1/4 cup warm water ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1/4 cup butter or margarine, melted ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 cup warm milk ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 egg, beaten ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 tablespoon sugar ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1/2 teaspoon salt ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 envelope (.25 ounce) active dry yeast ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1/2 cup butter or margarine, softened ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 cup brown sugar ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("3 teaspoons cinnamon ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 container (16 ounces) cream cheese frosting ")])])])]), _vm._v(" "), _c('p', [_vm._v("In a bowl, combine flour and dry pudding mix. In the pan for your bread machine, add water,\n        melted butter, milk, egg, sugar, and salt. Spoon flour mixture evenly over top and then\n        sprinkle yeast over flour layer. Set bread machine to dough cycle and start. ")]), _vm._v(" "), _c('p', [_vm._v("When the dough cycle finishes, roll dough into a 10 x 17-inch rectangle on a lightly\n        floured large cutting board. In a microwave safe bowl, combine butter, brown sugar, and\n        cinnamon. Microwave for 10 to 15 seconds. Stir and spread brown sugar mixture over dough.\n        Starting with the widest end, roll dough into a log. Slice into 16 pieces and then place on\n        a baking sheet prepared with nonstick spray. Allow dough to rise in a warm place for 45\n        minutes, or until double in size. Preheat oven to 350 degrees. Bake for 17 to 20 minutes.\n        While warm, top with desired amount of cream cheese frosting. Makes 16 rolls.")])]), _c('h2', [_c('a', {
    attrs: {
      "id": "d0e57",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }), _c('a', {
    attrs: {
      "id": "d0e90",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Orange Rolls ")])]), _c('a', {
    attrs: {
      "id": "d0e90",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('table', {
    staticClass: "simplelist",
    attrs: {
      "border": "0",
      "summary": "Simple list"
    }
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("4 cups bread flour ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1/2 small box instant vanilla pudding mix ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1/4 cup warm water ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1/4 cup butter or margarine, melted ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 cup warm milk ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 egg, beaten ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 tablespoon sugar ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1/2 teaspoon salt ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 envelope (.25 ounce) active dry yeast ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 package (8 ounces) cream cheese, softened ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1/2 cup sugar ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1-1/2 tablespoons grated orange rind ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 cup powdered sugar ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("2 tablespoons orange juice ")])])])]), _vm._v(" "), _c('p', [_vm._v("In a bowl, combine flour and dry pudding mix. In the pan for your bread machine, add water,\n        butter, milk, egg, 1 tablespoon sugar, and salt. Spoon flour mixture evenly over top and\n        then sprinkle yeast over flour layer. Set bread machine to dough cycle and start. ")]), _vm._v(" "), _c('p', [_vm._v("Preheat oven to 350 degrees. ")]), _vm._v(" "), _c('p', [_vm._v("When the dough cycle finishes, roll dough into a 10 x 17-inch rectangle on a lightly\n        floured large cutting board. Mix cream cheese, 1/2 cup sugar, and orange rind together.\n        Spread over rolled-out dough. Starting with the widest end, roll dough into a tight log. Cut\n        into 16 pieces and place on a baking sheet prepared with nonstick spray. Allow dough to rise\n        25 minutes. Bake for 17 to 20 minutes. ")]), _vm._v(" "), _c('p', [_vm._v("Mix together the powdered sugar and orange juice until smooth. Spread over warm rolls.\n        Makes 16 rolls.")])]), _c('h2', [_c('a', {
    attrs: {
      "id": "d0e90",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }), _c('a', {
    attrs: {
      "id": "d0e129",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Overnight Pecan Sticky Buns ")])]), _c('a', {
    attrs: {
      "id": "d0e129",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('table', {
    staticClass: "simplelist",
    attrs: {
      "border": "0",
      "summary": "Simple list"
    }
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("3/4 cup pecan halves ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("20 frozen Rhodes dinner rolls ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 small box cook and serve or instant butterscotch pudding mix ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1/2 cup butter or margarine ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1/2 cup brown sugar ")])])])]), _vm._v(" "), _c('p', [_vm._v("The night before serving, layer pecans over bottom of a generously buttered 9 x 13-inch\n        glass pan. Evenly space five rows of frozen rolls over pecans. Sprinkle dry pudding mix\n        evenly over rolls. ")]), _vm._v(" "), _c('p', [_vm._v("In a saucepan, melt butter and then stir in brown sugar; bring to a boil, stirring\n        constantly. Remove from heat and pour over frozen rolls. Cover with plastic wrap and leave\n        sitting on the counter overnight. ")]), _vm._v(" "), _c('p', [_vm._v("In the morning, preheat oven to 350 degrees. Remove plastic wrap and bake for 20 to 25\n        minutes until golden brown. Invert on a serving platter so the “sticky” runs down the sides.\n        Makes 20 buns.")])]), _c('h2', [_c('a', {
    attrs: {
      "id": "d0e129",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }), _c('a', {
    attrs: {
      "id": "d0e148",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Cinnamon Pull-Apart Ring ")])]), _c('a', {
    attrs: {
      "id": "d0e148",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('table', {
    staticClass: "simplelist",
    attrs: {
      "border": "0",
      "summary": "Simple list"
    }
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("1/2 cup brown sugar ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 small box cook and serve or instant butterscotch pudding mix ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1/4 cup sugar ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("2 teaspoons cinnamon ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("20 frozen Rhodes dinner rolls ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1/2 cup butter or margarine, melted ")])])])]), _vm._v(" "), _c('p', [_vm._v("The night before serving, combine brown sugar and dry pudding mix. In a separate small\n        bowl, combine sugar and cinnamon. Place one layer of 10 dinner rolls in a Bundt pan prepared\n        with nonstick spray. Sprinkle half of brown sugar mix over the rolls and then drizzle with\n        half of the butter. Sprinkle half of cinnamon sugar over top. Repeat layers with remaining\n        ingredients. Cover with plastic wrap and leave on counter overnight. ")]), _vm._v(" "), _c('p', [_vm._v("In the morning, preheat oven to 350 degrees. Remove plastic wrap and bake 25 to 30 minutes.\n        Let cool in the pan for 10 minutes before inverting onto a serving plate. Makes 10 to 12\n        servings.")])]), _c('h2', [_c('a', {
    attrs: {
      "id": "d0e148",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }), _c('a', {
    attrs: {
      "id": "d0e167",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Banana Bread ")])]), _c('a', {
    attrs: {
      "id": "d0e167",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('table', {
    staticClass: "simplelist",
    attrs: {
      "border": "0",
      "summary": "Simple list"
    }
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("2 medium bananas, mashed ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1/4 cup applesauce ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1/4 cup vegetable oil ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1/2 cup water ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("3/4 teaspoon cinnamon ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("3 eggs ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 banana or spice cake mix ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 small box instant banana pudding mix ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1-1/4 cups finely chopped nuts or mini chocolate chips ")])])])]), _vm._v(" "), _c('p', [_vm._v("Preheat oven to 350 degrees. ")]), _vm._v(" "), _c('p', [_vm._v("In a large bowl, combine bananas, applesauce, oil, water, and cinnamon. Whisk in each egg,\n        one at a time. Gradually stir in cake mix and then dry pudding mix. Fold nuts or chocolate\n        chips into batter. Spread batter into two 9 x 5-inch bread pans prepared with nonstick\n        spray. Bake for 35 to 45 minutes, or until a toothpick inserted in the center comes out\n        clean. Makes 2 loaves. ")])]), _c('h2', [_c('a', {
    attrs: {
      "id": "d0e167",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }), _c('a', {
    attrs: {
      "id": "d0e192",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Cinnamon Bread ")])]), _c('a', {
    attrs: {
      "id": "d0e192",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('table', {
    staticClass: "simplelist",
    attrs: {
      "border": "0",
      "summary": "Simple list"
    }
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("2 eggs, beaten ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1-1/2 cups milk ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1/4 cup vegetable oil ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("3/4 cup applesauce ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 teaspoon vanilla ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("3 cups bread flour ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1-1/2 cups sugar ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 large box instant vanilla pudding mix ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1-1/2 teaspoons baking powder ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1/2 teaspoon baking soda ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1/2 teaspoon salt ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("2 teaspoons cinnamon ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("2 tablespoons cinnamon sugar ")])])])]), _vm._v(" "), _c('p', [_vm._v("Preheat oven to 325 degrees. ")]), _vm._v(" "), _c('p', [_vm._v("In a large bowl, combine eggs, milk, oil, applesauce, and vanilla. ")]), _vm._v(" "), _c('p', [_vm._v("In a separate bowl, combine flour, sugar, dry pudding mix, baking powder, baking soda,\n        salt, and cinnamon. Gradually stir flour mixture into milk mixture until smooth. Spread\n        batter into two 9 x 5-inch bread pans prepared with nonstick spray. Sprinkle cinnamon sugar\n        over top. Bake for 50 to 60 minutes, or until a toothpick inserted in the center comes out\n        clean. Makes 2 loaves. ")])]), _c('h2', [_c('a', {
    attrs: {
      "id": "d0e192",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }), _c('a', {
    attrs: {
      "id": "d0e227",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Easy Lemon Poppy Seed Bread ")])]), _c('a', {
    attrs: {
      "id": "d0e227",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('table', {
    staticClass: "simplelist",
    attrs: {
      "border": "0",
      "summary": "Simple list"
    }
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("4 eggs ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1/4 cup vegetable oil ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1/4 cup applesauce ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 cup water ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 lemon cake mix ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 small box instant lemon pudding mix ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1/4 cup poppy seeds ")])])])]), _vm._v(" "), _c('p', [_vm._v("Preheat oven to 350 degrees. ")]), _vm._v(" "), _c('p', [_vm._v("In a large bowl, blend together eggs, oil, applesauce, and water with an electric mixer.\n        Gradually stir in cake mix and then dry pudding mix. Stir in poppy seeds. Spread batter into\n        two 8 x 4-inch bread pans prepared with nonstick spray. Bake for 35 to 45 minutes, or until\n        a toothpick inserted in the center comes out clean. Makes 2 loaves. ")])]), _c('h2', [_c('a', {
    attrs: {
      "id": "d0e227",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }), _c('a', {
    attrs: {
      "id": "d0e248",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Pumpkin Bread ")])]), _c('a', {
    attrs: {
      "id": "d0e248",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('table', {
    staticClass: "simplelist",
    attrs: {
      "border": "0",
      "summary": "Simple list"
    }
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("5 eggs, beaten ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("3/4 cup applesauce ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1/2 cup vegetable oil ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("2 cups pumpkin puree ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 cup brown sugar ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 cup sugar ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("2 cups bread flour ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("2 small boxes instant coconut cream pudding mix* ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 teaspoon baking soda ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 teaspoon salt ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1-1/2 teaspoons cinnamon ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 cup mini chocolate chips or chopped nuts ")])])])]), _vm._v(" "), _c('p', [_vm._v("Preheat oven to 325 degrees. ")]), _vm._v(" "), _c('p', [_vm._v("In a large bowl, combine eggs, applesauce, oil, pumpkin, and sugars until smooth. ")]), _vm._v(" "), _c('p', [_vm._v("In a separate bowl, combine flour, pudding mix, baking soda, salt, and cinnamon. Gradually\n        stir flour mixture into wet mixture until just combined. Stir in chocolate chips or nuts.\n        Spread batter into two 9 x 5-inch bread pans prepared with nonstick spray. Bake for 1 hour,\n        or until the top springs back when touched. Makes 2 loaves. ")]), _vm._v(" "), _c('p', [_vm._v("*Instant vanilla pudding mix can be substituted.")])]), _c('h2', [_c('a', {
    attrs: {
      "id": "d0e248",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }), _c('a', {
    attrs: {
      "id": "d0e283",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Blackberry Muffins ")])]), _c('a', {
    attrs: {
      "id": "d0e283",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('table', {
    staticClass: "simplelist",
    attrs: {
      "border": "0",
      "summary": "Simple list"
    }
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("1 white cake mix ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 small box instant vanilla pudding mix ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("3/4 cup water ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("3 eggs, beaten ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1/2 cup applesauce ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1-1/2 to 1-3/4 cups frozen blackberries, thawed and drained ")])])])]), _vm._v(" "), _c('p', [_vm._v("Preheat oven to 350 degrees. Prepare cups of muffin pan with nonstick spray and flour, or\n        use paper liners. ")]), _vm._v(" "), _c('p', [_vm._v("Combine cake mix, dry pudding mix, water, eggs, and applesauce. Using a knife, cut\n        blackberries into small chunks. Stir berries into batter. Fill muffin cups three-fourths\n        full. Bake 19 to 23 minutes, or until light golden brown on top. Makes 24 muffins.")])]), _c('h2', [_c('a', {
    attrs: {
      "id": "d0e283",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }), _c('a', {
    attrs: {
      "id": "d0e302",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Double Chocolate Chip Muffins ")])]), _c('a', {
    attrs: {
      "id": "d0e302",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('table', {
    staticClass: "simplelist",
    attrs: {
      "border": "0",
      "summary": "Simple list"
    }
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("3 eggs, beaten ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1/4 cup applesauce ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1/4 cup vegetable oil ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("3/4 cup water ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1/2 teaspoon almond or vanilla flavoring ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 chocolate cake mix ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 small box instant chocolate pudding mix ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("3/4 cup mini or regular chocolate chips, frozen ")])])])]), _vm._v(" "), _c('p', [_vm._v("Preheat oven to 350 degrees. Prepare cups of muffin pan with nonstick spray and flour, or\n        use paper liners. ")]), _vm._v(" "), _c('p', [_vm._v("In a large bowl, combine eggs, applesauce, oil, water, and flavoring. Gradually mix in cake\n        and pudding mixes until combined. Stir in frozen chocolate chips. Fill muffin cups\n        three-fourths full. Bake for 25 to 30 minutes. Makes 20 muffins.")])]), _c('h2', [_c('a', {
    attrs: {
      "id": "d0e302",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }), _c('a', {
    attrs: {
      "id": "d0e325",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Pecan Muffins ")])]), _c('a', {
    attrs: {
      "id": "d0e325",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('table', {
    staticClass: "simplelist",
    attrs: {
      "border": "0",
      "summary": "Simple list"
    }
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("1 butter pecan or spice cake mix ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 small box instant coconut cream pudding mix ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("4 eggs ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1/2 cup applesauce ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 cup water ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 cup chopped pecans ")])])])]), _vm._v(" "), _c('p', [_vm._v("Preheat oven to 350 degrees. Prepare cups of muffin pan with nonstick spray and flour, or\n        use paper liners. ")]), _vm._v(" "), _c('p', [_vm._v("In a large bowl, combine all ingredients until well blended. Fill muffin cups three-fourths\n        full. Bake 19 to 23 minutes, or until light golden brown on top. Makes 24 muffins. ")])])]), _c('a', {
    attrs: {
      "id": "d0e325",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ef27399","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ch02.vue
// module id = 75
// module chunks = 0